import { useState, useEffect } from "react";
import { GetBrands } from 'services/other/brand.service';
import { useSelector, useDispatch } from "react-redux";

const useItemDropdown = () => {
    const dispatch = useDispatch();
    
    const { brandList } = useSelector((state) => state.brandList);

    const [brandDropdown, setBrandDropdown] = useState([]);


    useEffect(() => {
        dispatch(GetBrands());
    }, []);

    return {
        brandDropdown, 
        setBrandDropdown, 
        brandList,
    };
};

export default useItemDropdown;
